import React from 'react';
import { WidgetProps } from '@wix/yoshi-flow-editor';
import { Spinner } from 'wix-ui-tpa/cssVars';

import { withOnlineOrdersStorageProvider } from '../storage';
import { withLayoutSizeProvider } from '../../../components-shared/LayoutSizeProvider';
import { RtlProvider } from '../../../components-shared/RtlProvider';
import EmptyState from '../components/EmptyState';
import FulfillmentSection from '../components/FulfillmentSection';
import Header from '../components/Header';
import MenuList from '../components/MenuList';
import Navigation from '../components/Navigation';
import { LAYOUT_BREAKPOINTS_START } from '../../../utils/constants';

import { useHooks } from './useHooks';
import { useHeaderProps } from './useHeaderProps';
import { st, classes } from './Widget.st.css';
import { onlineOrdersDataHooks } from './constants';

const Widget: React.FC<WidgetProps> = () => {
  const { layoutSize, widgetState } = useHooks();
  const headerProps = useHeaderProps();

  const renderContent = () => {
    switch (widgetState) {
      case 'loading':
        return (
          <EmptyState>
            <Spinner />
          </EmptyState>
        );

      case 'empty':
        return (
          <>
            <Header {...headerProps} />
            <FulfillmentSection />
            <EmptyState />
          </>
        );

      case 'content':
        return (
          <>
            <Header {...headerProps} />
            <FulfillmentSection />
            <Navigation />
            <MenuList />
          </>
        );

      default:
        return null;
    }
  };

  return (
    <RtlProvider>
      <div
        className={st(classes.root, { [layoutSize]: true })}
        data-hook={onlineOrdersDataHooks.root()}
      >
        <div className={classes.contentWrapper}>{renderContent()}</div>
      </div>
    </RtlProvider>
  );
};

export default withLayoutSizeProvider(
  withOnlineOrdersStorageProvider(Widget),
  LAYOUT_BREAKPOINTS_START,
);
